import { render, staticRenderFns } from "./DeletedServiceAccountsPage.vue?vue&type=template&id=f26b444c&scoped=true"
import script from "./DeletedServiceAccountsPage.vue?vue&type=script&lang=ts"
export * from "./DeletedServiceAccountsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26b444c",
  null
  
)

export default component.exports